const validateCommunityLanguageCode = (langCode) => {
    if(['en', 'id', 'th','ph', 'my', 'vn'].indexOf(langCode) !== -1) {
        return true;
    }
    return false;
}

export default validateCommunityLanguageCode;
